import { createGlobalStyle } from 'styled-components';
import "@fontsource/overpass/";
import "@fontsource/overpass/900.css";
import "@fontsource/overpass/600.css";
import "@fontsource/overpass/500.css";
import "@fontsource/overpass/400.css";
import "@fontsource/overpass/300.css";
import "@fontsource/overpass/200.css";
import { up, down, between, only } from 'styled-breakpoints';

export const GlobalStyle = createGlobalStyle`
  html{
    font-family: "Overpass";
    font-size: 16px;
    
    ${down('sm')} {
      font-size: 11px;
    }
    ${only('sm')} {
      font-size: 11px;
    }
    ${only('md')} {
      font-size: 12px;
    }
    ${only('lg')} {
      font-size: 14px;
    }
    ${only('xl')} {
      font-size: 16px;
    }  
    ${up('xl')} {
      font-size: 16px;
    }         
    overflow-x: hidden;
  }
  body {
    margin: 0;
    padding: 0;

  }

  a{
    text-decoration: none;
  }

`;

export const palette = {
  text: {
    primary: '#0D2C57',
    white: '#ffffff',
    lightBlue: '#1FAAF4',
    lightGreen: '#0AC69D',
    green: '#33B93F',
    gold: '#E6D585',
    black: '#000000',
  },
  white: '#ffffff',
  black: '#000000',
  orange: '#F7AE29',
  green: '#33B93F',
  lightGreen: '#0AC69D',
  gold: '#E6D585',
  grey: '#EBEBEB',
  red: '#F60B46',
  brightGreen: '#00DFB8'
}